import { apiInstance } from "@/utils/api-instance";
import { ENDPOINTS } from "@/utils/constants";

export const listSector = async (payload) => {
    const { data } = await apiInstance.post(ENDPOINTS.SECTOR_LIST, payload);
    return data
}
